import firebase from '@/firebase-init.js'
import { uuid, groupBy } from '@/utils'
import { format } from 'date-fns'
import Vue from 'vue'

console.log('🚌')
const EventBus = new Vue()

const PROBLEMS_COLLECTION_NAME = 'problems'
const USERS_COLLECTION_NAME = 'users'
const FIELDS_COLLECTION_NAME = 'fields'

export default {
  queryProblems,
  problemPassesFilters,
  assembleProblem,
  assembleImage,
  saveImage,
  assembleLabels,
  createProblem,
  updateProblem,
  getProblem,
  getProblems,
  getProblemsCreatedByUser,
  getProblemsForProblemType,
  getFields,
  addStatus,
  getCurrentUserAndProfile,
  updateCurrentUserAndProfile,
  deleteUserPhotoURL,
  assembleStatus,
  decorateNewStatus,
  EventBus,
  calculateTotals,
  accept,
  getProblemReportedTimeForSorting
}
const unsubscribe = {
  problems: undefined,
  userProfile: undefined
}

const defaults = {
  label: {
    'locale': 'en',
    'short': 'None',
    'medium': 'None',
    'long': 'None'
  }
}

const cache = {
  fields: undefined,
  fieldsForDecorating: undefined,
  problems: {},
  problemsValid: false,
  problemsGetTime: new Date().getTime(),
  id: uuid(),
  user: undefined,
  userProfile: undefined
}

console.log('🔥')
firebase.auth().onAuthStateChanged(async (user) => {
  console.log('🐑 cached in [%s]', cache.id)
  if (user) {
    cache.user = user
    await setUserProfileForCurrentUser()
    subscribeCurrentUserProfileChanges()
  } else {
    cache.user = null
    cache.userProfile = null
    cache.problems = {}
    cache.problemsValid = false
    cache.problemsGetTime = null
    cache.fields = null
    cache.fieldsForDecorating = null
  }
  EventBus.$emit('user-auth-state-changed', user)
})

function calculateTotals (problems) {
  const unarchived = problems.filter(p => p.status && p.status.value > -1)
  const totals = {
    problems: unarchived.length,
    rooms: Object.keys(groupBy(unarchived.map((prob) => { prob.roomKey = prob.school.value + prob.roomName; return prob }), 'roomKey')).length,
    schools: Object.keys(groupBy(unarchived.map((prob) => { prob.schoolId = prob.school.value; return prob }), 'schoolId')).length,
    people: Object.keys(groupBy(unarchived.map((prob) => { prob.userId = prob.status.creatorUserId; return prob }), 'userId')).length
  }
  return totals
}

async function setUserProfileForCurrentUser() {
  const snapshot = await firebase.firestore().collection(USERS_COLLECTION_NAME).doc(cache.user.uid).get()
  if (snapshot.exists) {
    cache.userProfile = snapshot.data()    
  } else {
    const profile = assembleCurrentUserProfile()
    await firebase.firestore().collection(USERS_COLLECTION_NAME).doc(cache.user.uid).set(profile)
    cache.userProfile = profile
  }
}

async function getCurrentUserAndProfile () {
  if (cache.user && cache.userProfile) {
    return {
      user: cache.user,
      profile: cache.userProfile
    }
  }
  return {
    user: cache.user,
    profile: cache.user ? await getUserProfile(cache.user.uid) : undefined
  }
}

async function getUserProfile (userId) {
  const snapshot = await firebase.firestore().collection(USERS_COLLECTION_NAME).doc(userId).get()
  if (!snapshot.exists) {
    return assembleCurrentUserProfile()
  }
  return snapshot.data()
}

function assembleCurrentUserProfile () {
  console.log('hmm')
  return {
    organization: '',
    displayName: cache.user.displayName,
    email: cache.user.email,
    photoURL: cache.user.photoURL
  }
}

async function updateCurrentUserAndProfile (displayName, photoURL, profile) {
  try {
    await cache.user.updateProfile({
      displayName: displayName,
      photoURL: photoURL
    })
    if (profile) {
      profile.displayName = displayName
      profile.photoURL = photoURL
      await firebase.firestore().collection(USERS_COLLECTION_NAME).doc(cache.user.uid).set(profile)
    }
    cache.userProfile = profile
  } catch (error) {
    console.log('problem updating user profile', error)
  }
  return await getCurrentUserAndProfile()
}

async function deleteUserPhotoURL(user) {
  try {
    await user.updateProfile({
      photoURL: ''
    })
    await firebase.firestore().collection(USERS_COLLECTION_NAME).doc(cache.user.uid).set({
        photoURL: ''
      }, { merge: true })
  } catch (error) {
    console.log('error deleting photoURL for %s', cache.user.uid, error)
  }
}

function subscribeCurrentUserProfileChanges () {
  const userProfileRef = firebase.firestore().collection(USERS_COLLECTION_NAME).doc(cache.user.uid)
  unsubscribe.userProfile = userProfileRef.onSnapshot(function(documentSnapshot) {
    // console.log('🦍', documentSnapshot)
    EventBus.$emit('user-profile-modified-remotely', documentSnapshot.data())
  }, function(error) {
    console.log('🦍 unsubscribe user profile')
    unsubscribe.userProfile()
  })
}

const problemsRef = firebase.firestore().collection(PROBLEMS_COLLECTION_NAME)

function buildQuery (selectedFields) {
  let ref = problemsRef
  if (['Reporter'].indexOf(cache.userProfile.role) > -1) {
    ref = ref.where('creatorUserId', '==', cache.user.uid)
  } else if (['Admin','ViewAdmin'].indexOf(cache.userProfile.role) === -1) {
    ref = ref.where('status.value', '>', 1)
  } else {
    ref = ref.orderBy('status.lastModified', 'desc')
  }
  if (selectedFields && selectedFields['status']) {
    const values = selectedFields['status'].map(v => parseInt(v.value))
    if(values.length > 0) {
      if (values.length > 10) {
        values = values.slice(0,9) // firebase currently limits in to 10 elements
      }
      ref = ref.where('status.value', 'in', values)
    }
  }
  return ref
}

function subscribeProblems (ref) {
  unsubscribe.problems = ref
  .onSnapshot(function(snapshot) {
      snapshot.docChanges().forEach(function(change) {
          if (change.type === 'added') {
            // console.log('💸 read %s', change.doc.id)
            if (!(change.doc.id in cache.problems)) {
              decorateProblem(change.doc.data(), change.doc.id).then(problem => {
                cache.problems[change.doc.id] = problem
                // console.log('💰 added problem %s to cache %s', change.doc.id, problem, cache.id)
                EventBus.$emit('problem-added-remotely', problem)
              })  
            }
          }
          if (change.type === 'modified') {
            decorateProblem(change.doc.data(), change.doc.id).then(problem => {
              // console.log('💵 updated problem %s in cache [%s] %i', change.doc.id, cache.id, problem.status.value, problem)
              cache.problems[change.doc.id] = problem
              EventBus.$emit('problem-modified-remotely', problem)
            })
          }
          if (change.type === 'removed') {
            delete cache.problems[change.doc.id]
            // console.log('💸 deleted problem %s from cache [%s]', change.doc.id, cache.id)
            EventBus.$emit('problem-removed-remotely', change.doc.id)
          }
      })
  }, function(error) {
    console.log('🦍 unsubscribe problems')
    unsubscribe.problems()
  })
}

function problemPassesFilters (selectedFields, problem) {
  let is = true
  Object.keys(selectedFields).forEach(fieldName => {
    const values = selectedFields[fieldName].map(v => v.value)
    if(values.length > 0) {
      is = values.indexOf(problem[fieldName].value.toString()) > -1
    }
  })
  return is
}

async function queryProblems(selectedFields) {
  if(selectedFields == null) {
    throw('304 Not Modified')
  }
  let problems = Array.from(await getProblems(selectedFields))
  Object.keys(selectedFields).forEach(fieldName => {
    if (fieldName === 'status') {
      return
    }
    const values = selectedFields[fieldName].map(v => parseInt(v.value))
    // console.log(fieldName, values)
    if(values.length > 0) {
      try {
        problems = problems.filter(prob => {
          // console.log('🤢 %i', values.indexOf(prob[fieldName].value), prob[fieldName].value)
          if (prob[fieldName]) {
            return values.indexOf(prob[fieldName].value) > -1
          } else {
            return false
          }
        })
      } catch (error) {
        // console.log('👿', error)
      }
    }
    // console.log('😡', problems)
  })
  // console.log('returning problems', problems)
  return problems
}

async function getProblemsForProblemType (problemTypeValue) {
  const problemsRef = firebase.firestore().collection(PROBLEMS_COLLECTION_NAME)
  var query = problemsRef.where('problemType.value', '==', problemTypeValue)
  const snapshot = await query.get()
  if (snapshot.empty) {
    throw('404 Not Found')
  }
  const assembled = snapshot.docs.map(doc => decorateProblem(doc.data(), doc.id))
  const problems = await Promise.all(assembled)
  return problems 
}

/**
 * Return the problems created by the user
 * @param {*} userId optional, use currently logged in user if not provided
 */
async function getProblemsCreatedByUser (userId) {
  const uid = userId ? userId : cache.user.uid
  const problemsRef = firebase.firestore().collection(PROBLEMS_COLLECTION_NAME)
  var query = problemsRef.where('creatorUserId', '==', uid)
  const snapshot = await query.get()
  if (snapshot.empty) {
    throw('404 Not Found')
  }
  const assembled = snapshot.docs.map(doc => decorateProblem(doc.data(), doc.id))
  const problems = await Promise.all(assembled)
  return problems 
}

async function getProblems (selectedFields) {
  // if (cache.problemsValid) {
  //   console.log('returning cached problems from %s', cache.id)
  //   return Object.values(cache.problems)
  // }
  await getCurrentUserAndProfile()
  let ref = buildQuery(selectedFields)
  let snapshot = await ref.get()
  if (snapshot.empty) {
    throw('404 Not Found')
  }
  const assembled = snapshot.docs.map(doc => decorateProblem(doc.data(), doc.id))
  const problems = await Promise.all(assembled)
  problems.map(problem => cache.problems[problem.id] = problem)
  cache.problemsGetTime = new Date().getTime()
  cache.problemsValid = true
  subscribeProblems(ref)
  return problems 
}

async function getProblem (problemId) {
  const snapshot = await firebase.firestore().collection(PROBLEMS_COLLECTION_NAME).doc(problemId).get()
  if (snapshot.empty) {
    throw('404 Not Found')
  }
  const problem = await decorateProblem(snapshot.data(), snapshot.id)
  return problem
}

async function decorateProblem (problem, problemId) {
  await assembleLabels(problem)
  if (problem.statusHistory) {
    problem.statusHistory = problem.statusHistory.sort((a,b) => { return b.lastModified - a.lastModified })
  } else {
    problem.statusHistory = []
  }
  if (!problem.images) {
    problem.images = []
  }
  problem.id = problemId
  return problem
}

async function assembleLabels (problem) {
  // get the field values to decorate the problem values stored in the database
  const fields = await getFieldsForDecorating()
  Object.keys(fields).forEach(fieldName => {
    if (problem[fieldName] && problem[fieldName].value !== null) {
      try {
        problem[fieldName].labels = fields[fieldName].values[problem[fieldName].value].labels
      } catch (err) {
        // console.log('🤦🏻‍♀️ %s %s %s', problem.id, fieldName, problem[fieldName].value)
        if (isNaN(problem[fieldName.value])) {
          problem[fieldName].value = null
          problem[fieldName].labels = defaults.label
        } else {
          problem[fieldName].labels = {locale: 'en', long: problem[fieldName].value, medium: problem[fieldName].value, short: problem[fieldName].value}
        }
      }
    } else {
      // backwards compatibility for new field names being added to database
      if (!problem[fieldName]) {
        problem[fieldName] = { value: null }
      }
      problem[fieldName].labels = defaults.label
    }
    spreadLabels(problem[fieldName])
  })
  if (problem.statusHistory) {
    problem.statusHistory.forEach(status => {
      try {
        status.labels = fields.status.values[status.value].labels
        spreadLabels(status)
      } catch (err) {
        console.log(err, status, problem)
      }
    })
  }
  return problem
}

/**
 * use a default locale
 * cache it on first use
 * this function returns field objects that can be used by the UI
 */
async function getFields () {
  if (cache.fields) {
    return cache.fields
  }

  let fields = {}
  const snapshots = await firebase.firestore().collection(FIELDS_COLLECTION_NAME).get()
  snapshots.forEach(snapshot => {
    let field = snapshot.data()
    // flatten the field labels
    field.labels = Object.values(field.labels)[0]
    spreadLabels(field)
    // flatten value labels for locale
    Object.values(field.values).forEach(value => {
      value.labels = Object.values(value.labels)[0]
      spreadLabels(value)
    })
    field.values = Object.values(field.values)
    field.values.sort((a, b) => {
      if (a.sequence === b.sequence) {
        return a.labels['short'].localeCompare(b.labels['short'])
      } else {
        return a.sequence - b.sequence
      }
    })
    if (field.name === 'status') {
      getCurrentUserAndProfile().then(uap => {
        if (['Admin','ViewAdmin'].indexOf(uap.profile.role) === -1) {
          field.values = field.values.filter(vo => ('-1,0,1'.indexOf(vo.value) === -1))
        } 
      })
    }
    fields[field.name] = field
  })
  cache.fields = fields
  return cache.fields
}

/**
 * use a default locale
 */
async function getFieldsForDecorating () {
  if (cache.fieldsForDecorating) {
    return cache.fieldsForDecorating
  }
  let fields = {}
  const snapshots = await firebase.firestore().collection(FIELDS_COLLECTION_NAME).get()
  snapshots.forEach(snapshot => {
    let field = snapshot.data()
    // flatten the field labels
    field.labels = Object.values(field.labels)[0]
    spreadLabels(field)
    // flatten value labels for locale
    Object.values(field.values).forEach(value => {
      value.labels = Object.values(value.labels)[0]
      spreadLabels(value)
    })
    fields[field.name] = field
  })
  cache.fieldsForDecorating = fields
  return cache.fieldsForDecorating
}

function spreadLabels (field) {
  Object.keys(field.labels).forEach(labelKey => {
    if (labelKey !== 'locale') {
      field[labelKey + 'Label'] = field.labels[labelKey]
    }
  })
}

/**
 * Supports adding a status from the UI ... pushes the current status to history and replaces it with
 * the new status
 * @param {*} problem 
 * @param {*} newStatus 
 */
async function addStatus (problem, status) {
  const newStatus = JSON.parse(JSON.stringify(status))
  if (newStatus.value != null && newStatus.lastModified == null) {
    newStatus.lastModified = new Date().getTime()
    newStatus.lastModifiedDate = format(newStatus.lastModified, 'YYYY-MM-DDTHH:mm:ss.SSSZ')
  }
  newStatus.value = parseInt(newStatus.value)
  problem.statusHistory.push(problem.status)
  problem.statusHistory = problem.statusHistory.sort((a,b) => { return b.lastModified - a.lastModified })
  problem.status = newStatus
  problem.statusValuesIndex.push(parseInt(newStatus.value))
  // console.log(problem.id)
  return await updateProblem(problem)
}

function decorateStatus (problem) {
  if (problem.status.value != null && problem.status.lastModified == null) {
    problem.status.lastModified = new Date().getTime()
    problem.status.lastModifiedDate = format(problem.status.lastModified, 'YYYY-MM-DDTHH:mm:ss.SSSZ')
  }
  const values = problem.statusHistory.map(status => status.value)
  problem.statusValuesIndex = values
  return problem
}

async function updateProblem (problem) {
  decorateStatus(problem)

  // process any new images
  const newImages = []
  const newImagePuts = []
  problem.images.forEach(image => {
    if (image.file) {
      newImages.push(image)
      newImagePuts.push(putImage(image))
    }
  })
  if (newImages.length > 0) {
    const responses = await Promise.all(newImagePuts)
    responses.forEach(response => {
      const image = problem.images.find(img => img.storageName === response.metadata.name)
      image.storageFullPath = response.metadata.fullPath
    })
    const gets = newImages.map(getDownloadUrl)
    await Promise.all(gets)
  }
  await updateProblemInFirestore(problem)
  await decorateProblem(problem, problem.id)
  // console.log(problem)
  return problem
}

async function createProblem (problem) {
  
  const storagePuts = problem.images.map(putImage)
  const responses = await Promise.all(storagePuts)

  responses.forEach(response => {
    const image = problem.images.find(img => img.storageName === response.metadata.name)
    image.storageFullPath = response.metadata.fullPath
    delete image.dataUrl
    delete image.file
  })

  const gets = problem.images.map(getDownloadUrl)
  await Promise.all(gets)

  const ref = await addProblemToFirestore(problem)
  await decorateProblem(problem, ref.id)
  return problem
}


async function saveImage (image) {
  const response = await putImage(image)
  image.storageFullPath = response.metadata.fullPath
  const downloadUrl = await getDownloadUrl(image)
  image.downloadUrl = downloadUrl
  return image
}

async function getDownloadUrl (image) {
  const storageRef = firebase.storage().ref(image.storageFullPath)
  image.downloadUrl = await storageRef.getDownloadURL()
  return image.downloadUrl
}

async function putImage(image) {
  const storageRef = firebase.storage().ref('images').child(image.storageName)
  const result = await storageRef.put(image.file)
  return result
}

async function addProblemToFirestore (problem) {
  const problemForFirestore = await getCleanClone(problem)
  const ref = await firebase.firestore().collection(PROBLEMS_COLLECTION_NAME).add(problemForFirestore)
  return ref
}

async function updateProblemInFirestore (problem) {
  const problemForFirestore = await getCleanClone(problem)
  await firebase.firestore().collection(PROBLEMS_COLLECTION_NAME).doc(problem.id).set(problemForFirestore)
}

async function getCleanClone (problem) {
  const problemForFirestore = JSON.parse(JSON.stringify(problem))

  delete problemForFirestore.id

  // clean unnecessary image fields before writing to firestore
  problemForFirestore.images.forEach(image => {
    delete image.dataUrl
    delete image.file
  })

  // remove labels object from fields before writing to firestore
  const fields = await getFieldsForDecorating()
  Object.keys(fields).forEach(fieldName => {
    cleanField(problemForFirestore[fieldName])
  })

  // rebuild the index after cleaning
  const cleanIndex = []
  if (problemForFirestore.statusHistory) {
    problemForFirestore.statusHistory.forEach(status => {
      cleanField(status)
      cleanIndex.push(status.value)
    })
  }
  cleanIndex.push(problemForFirestore.status.value)
  
  problemForFirestore.statusValuesIndex = cleanIndex
  // delete fields that the UI puts on the object
  delete problemForFirestore.userId
  delete problemForFirestore.schoolId
  delete problemForFirestore.roomKey

  return problemForFirestore
}

function cleanField (field) {
  delete field.labels
  delete field.shortLabel
  delete field.mediumLabel
  delete field.longLabel
  delete field.sequence
  field.value = parseInt(field.value)
}

/**
 * assemble a Problem object for the UI
 */
function assembleProblem () {
  let prob = {
    id: null,
    images: [],
    description: null,
    roomName: null,
    problemType: {
      value: null
    },
    floorType: {
      value: null
    },
    roomType: {
      value: null
    },
    school: {
      value: null
    },
    status: assembleStatus(), // current status
    statusHistory: [], // hold the history of status objects
    statusValuesIndex: [] // hold historical status values (for querying)
  }
  prob.creatorUserId = prob.status.creatorUserId
  prob.created = prob.status.lastModified
  prob.createdDate = prob.status.lastModifiedDate
  return prob
}

/**
 * 
 * @param {File} file 
 * @param {string} creatorUserId 
 * @param {string} creatorName 
 * @param {string} creatorOrganization 
 */
function assembleImage (file, creatorOrganization) {
  return {
    file: file,
    storageName: uuid(),
    storageFullPath: null,
    downloadUrl: null,
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
    name: file.name,
    type: file.type,
    size: file.size,
    creatorUserId: cache.user.uid,
    creatorName: cache.user.displayName,
    creatorOrganization: creatorOrganization ? creatorOrganization: null
  }
}

function decorateNewStatus (status) {
  const now = new Date()
  status.creatorUserId = cache.user.uid
  status.creatorName = cache.user.displayName
  status.creatorOrganization = cache.userProfile ? cache.userProfile.organization : ''
  status.lastModified = now.getTime()
  status.lastModifiedDate = format(now, 'YYYY-MM-DDTHH:mm:ss.SSSZ')
  return status
}

function assembleStatus () {
  const now = new Date()
  return {
    value: null,
    labels: {'locale':'en', 'short':'Select a status','medium':'Select a status','long':'Select a status'},
    longLabel: 'Select a status',
    shortLabel: 'Select a status',
    mediumLabel: 'Select a status',
    comment: '',
    creatorUserId: cache.user.uid,
    creatorName: cache.user.displayName,
    creatorOrganization: cache.userProfile ? cache.userProfile.organization : '',
    lastModified: now.getTime(),
    lastModifiedDate: format(now, 'YYYY-MM-DDTHH:mm:ss.SSSZ')
  }
}

async function accept(problem) {
  const status = assembleStatus()
  status.comment = 'Your report has been submitted to District facility managers for their response and action. You will be able to easily track and follow response & repair status on your mobile device. PFT will also be helping to expedite and track District actions and will be following up.'
  status.value = 2
  problem = await addStatus(problem, status)
  return problem
}

/**
 * @return now timestamp if not exists
 * @param {*} problem 
 */
function getProblemReportedTimeForSorting (problem) {
  let time = new Date().getTime()
  try {
    if (problem.status.value === 0) {
      time = problem.status.lastModified
    } else {
      const reportedStatus = problem.statusHistory.find(s => s.value === 0)
      if (reportedStatus) {
        time = reportedStatus.lastModified
      }
    }
  } catch (ignored) {}
  return time
}